//import Vue from 'vue';
import Vue from 'vue';
import Question from "./Question";

if (document.getElementById('form-question')) {
   Vue.config.productionTip = false;
   new Vue({
      render: h => h(Question)
   }).$mount('#form-question');
}
